function copyTextareaStyles(source: CSSStyleDeclaration, target: HTMLElement) {
  const properties = [
    "boxSizing",
    "width",
    "height",
    "overflowX",
    "overflowY",
    "borderTopWidth",
    "borderRightWidth",
    "borderBottomWidth",
    "borderLeftWidth",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "fontStretch",
    "fontSize",
    "fontSizeAdjust",
    "lineHeight",
    "fontFamily",
    "letterSpacing",
    "textTransform",
    "textIndent",
    "textDecoration",
    "textAlign",
    "direction",
    "wordSpacing",
    "tabSize",
    "whiteSpace",
    "wordBreak",
    "overflowWrap",
  ] as const;

  properties.forEach((property) => {
    target.style[property] = source[property];
  });
}

export function getTextareaCaretClientRect(
  textarea: HTMLTextAreaElement,
  selectionStart: number
): {
  x: number;
  y: number;
  top: number;
  left: number;
  right: number;
  bottom: number;
  width: number;
  height: number;
  toJSON: () => object;
} {
  const computedStyle = window.getComputedStyle(textarea);
  const textareaRect = textarea.getBoundingClientRect();
  const mirror = document.createElement("div");

  copyTextareaStyles(computedStyle, mirror);

  mirror.style.position = "absolute";
  mirror.style.visibility = "hidden";
  mirror.style.pointerEvents = "none";
  mirror.style.whiteSpace = "pre-wrap";
  mirror.style.wordWrap = "break-word";
  mirror.style.left = "0";
  mirror.style.top = "0";

  const before = textarea.value.slice(0, selectionStart);
  const after = textarea.value.slice(selectionStart) || ".";

  mirror.textContent = before;

  const marker = document.createElement("span");
  marker.textContent = after[0];
  mirror.appendChild(marker);

  document.body.appendChild(mirror);

  const markerRect = marker.getBoundingClientRect();
  const lineHeight = parseFloat(computedStyle.lineHeight || "0") || 20;
  const caretLeft =
    markerRect.left - mirror.getBoundingClientRect().left + textareaRect.left;
  const caretTop =
    markerRect.top -
    mirror.getBoundingClientRect().top +
    textareaRect.top -
    textarea.scrollTop;
  const left = caretLeft - textarea.scrollLeft;
  const top = caretTop;
  const width = 1;
  const height = lineHeight;
  const caretRect = {
    x: left,
    y: top,
    top,
    left,
    right: left + width,
    bottom: top + height,
    width,
    height,
    toJSON: () => ({}),
  };

  document.body.removeChild(mirror);

  return caretRect;
}
